// ABOUTME: Best-effort localStorage wrappers — swallow QuotaExceeded / SecurityError
// ABOUTME: Private browsing throws on every write; quota-exceeded throws after the cap

function warn(method: string, key: string, err: unknown): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.warn(`storage.${method} failed for "${key}":`, err);
  }
}

export function safeSet(key: string, value: string): boolean {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (err) {
    warn('set', key, err);
    return false;
  }
}

export function safeRemove(key: string): boolean {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (err) {
    warn('remove', key, err);
    return false;
  }
}

export function safeGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch (err) {
    warn('get', key, err);
    return null;
  }
}

export function safeGetJson<T>(key: string): T | null {
  const raw = safeGet(key);
  if (raw == null) return null;
  try {
    return JSON.parse(raw) as T;
  } catch (err) {
    warn('parseJson', key, err);
    return null;
  }
}

export function safeSetJson<T>(key: string, value: T): boolean {
  try {
    return safeSet(key, JSON.stringify(value));
  } catch (err) {
    warn('stringifyJson', key, err);
    return false;
  }
}
